"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Steper = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const RenderStepper_1 = __importDefault(require("./RenderStepper"));
const styles_1 = require("./styles");
const Steper = ({ exibirBotaoVoltar, btnVoltarClickHandler, activeStep, steps, fundoTransparatente, lazyLabels = [], }) => {
    return (react_1.default.createElement(styles_1.Container, { container: true, alignItems: "center", fundoTransparatente: fundoTransparatente },
        react_1.default.createElement(core_1.Hidden, { mdUp: true },
            react_1.default.createElement(Grid_1.default, { item: true }, exibirBotaoVoltar && (react_1.default.createElement(styles_1.KeyboardBackspaceIconMobileStyled, { onClick: btnVoltarClickHandler }))),
            react_1.default.createElement(styles_1.GridStyled, { item: true },
                react_1.default.createElement(RenderStepper_1.default, { steps: steps, activeStep: activeStep, lazyLabels: lazyLabels }))),
        react_1.default.createElement(core_1.Hidden, { smDown: true },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(RenderStepper_1.default, { steps: steps, activeStep: activeStep, lazyLabels: lazyLabels })))));
};
exports.Steper = Steper;
//# sourceMappingURL=index.js.map